import script from "./JournalThread.vue?vue&type=script&setup=true&lang=js"
export * from "./JournalThread.vue?vue&type=script&setup=true&lang=js"

import "./JournalThread.vue?vue&type=style&index=0&id=fc81fe00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc81fe00"]])

export default __exports__